<template>
  <div class="col-md-4 col-xl-4 mb-3" v-if="customFilter.filterable">

    <div class="dropdown" :id="'drop-'+uid ">
      <button class="btn btn-outline-filter dropdown-toggle" type="button">
        <span>{{ customFilter.label }} ({{ valuesForFilter.length }})</span>

      </button>
      <div class="dropdown-menu">

        <input :id="'search'+uid" v-model="search" class="form-control mb-3" type="text"
               :placeholder="$t('jobs.filter.search')">

        <div class="option-wrapper">
          <div class="custom-control custom-checkbox" v-for="(job, index) in searchByKey"
               :key="'customfilter-'+index+ uid">

            <input v-model="valuesForFilter"
                   :value="getTypeOfData === 'boolean'  ? index === 0 : job[customFilter.key]"
                   type="checkbox"
                   :id="'customfilter-'+index+ uid"
                   class="custom-control-input"
            >
            <label class="custom-control-label" :for="'customfilter-'+index+ uid">
              <span>{{ getTypeOfData === 'boolean'  ? getBooleanLabel(index === 0) : job[customFilter.key] }}</span>
            </label>
          </div>
          <div class="custom-control custom-checkbox" v-for="(job, index) in getUniqueHydrate "
               :key="'customfilter-2'+index">
            <input v-model="valuesForFilter"
                   :value="job"
                   type="checkbox"
                   :id="'customfilter-2'+index"
                   class="custom-control-input"
            >
            <label class="custom-control-label" :for="'customfilter-2'+index">
              <span>{{ job }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @vuese
// @group StartStop
// This component renders the custom table filters that are used in the jobs table filter menu for the startstop.
export default {
  name: 'CustomTableFilters',
  props: {
    // @vuese
    // This hydrateds the already known values for the filters
    // Contains hydrateValues.values
    hydrateValues: {
      type: Object,
      required: true,
      default: null
    },
    // @vuese
    // This customFilter declared in the firestore record
    customFilter: {
      type: Object,
      required: true,
      default: null
    },
    // @vuese
    // Jobs are needed to search for values to filter on in the filter search
    jobs: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      uid: this._uid,
      search: '',
      valuesForFilter: []
    };
  },
  methods: {
    getBooleanLabel(value) {
      if (this.customFilter.booleanLabels) {
        if (value) {
          return this.customFilter.booleanLabels.true;
        } else {
          return this.customFilter.booleanLabels.false;
        }
      } else {
        if (value) {
          return this.$t('ui.yes');
        } else {
          return this.$t('ui.no');
        }
      }
    }
  },
  computed: {
    getUniqueHydrate() {
      // Booleans will have forces true/false options, so no hydrate needed
      if (this.getTypeOfData == 'boolean') {
        return [];
      }
      // IF IS NOT IN
      let unique = _.uniqBy(this.jobs.filter((job) => {
        if (job[this.customFilter.key]) {
          return job[this.customFilter.key].toString().toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
        }
      }), this.customFilter.key);
      unique = unique.map(u => {
        return u[this.customFilter.key];
      });
    },
    // @vuese
    // Search the jobs array
    searchByKey() {
      let data = [];
      let jobs = this.jobs;
      if (this.getTypeOfData == 'string') {
        data = _.uniqBy(this.jobs.filter((job) => {
          if (job[this.customFilter.key]) {
            return job[this.customFilter.key].toString().toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
          }
        }), this.customFilter.key);
      } else if (this.getTypeOfData == 'boolean') {
        data = [ true, false ];
      } else {
        data = [];
      }
      return data;

    },
    // @vuese
    // get the type of data from given customFilter.
    // Can be `string` , `object` , `array`
    getTypeOfData() {
      if (this.jobs[0]) {
        return typeof this.jobs[0][this.customFilter.key];
      }
      return null;
    }
  },
  watch: {

    valuesForFilter(newV, oldV) {
      // @vuese
      // sends the filters back to the parent component so it can be used in the datatable search function
      // fire whenever there is a change to the values of this current filter
      // @arg `this.valuesForFilter`
      this.$emit('filterUpdated', newV);
    }
  },
  created() {
    if (this.hydrateValues.values) {
      this.valuesForFilter = this.hydrateValues.values;
    }
  }
};

</script>

<style scoped>

</style>